export { default as IncomeDetailsTableContainer } from './IncomeDetailsTableContainer';
